import type { RouteRecordRaw } from 'vue-router'
import { getCommuneBySlug } from '../data/communeService'

/** Redirige /{ville} → /local/{ville} (URLs hub sans préfixe, ex. après migration SEO). */
export const localCommuneLegacyRedirect: RouteRecordRaw = {
  path: ':slug',
  redirect: (to) => {
    const slug = String(to.params.slug || '').toLowerCase()
    if (getCommuneBySlug(slug)) {
      return `/local/${slug}`
    }
    return { name: 'not-found', replace: true }
  }
}
